class DeathproofProductDetails extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const description = this.querySelector('[data-content="description"]');
    const content = Object.fromEntries(['description','specs','fitment','numbers'].map(key => [key, this.querySelector(`[data-content="${key}"]`)]));
    const fallback = this.querySelector('[data-fitment-fallback]');
    // Move existing content intact; never rewrite supplier data or product descriptions.
    const classify = text => {
      const label = text.trim().toLowerCase();
      if (/^(compatible models|compatibility|fitment|vehicle fitment|fits\b)/.test(label)) return 'fitment';
      if (/^(specifications|technical specifications|specs|technical data)\b/.test(label)) return 'specs';
      if (/^(part numbers|manufacturer part|supplier sku|oem (number|reference))\b/.test(label)) return 'numbers';
      return null;
    };
    for (const details of [...description.querySelectorAll('details')]) {
      const summary = details.querySelector(':scope > summary');
      const label = summary?.textContent || '';
      const destination = classify(label);
      if (destination) {
        summary.remove();
        content[destination].append(...details.childNodes);
        details.remove();
      } else if (/^description$/i.test(label.trim())) {
        summary.remove();
        details.replaceWith(...details.childNodes);
      }
    }
    for (const heading of [...description.querySelectorAll('h2,h3,h4')]) {
      const destination = classify(heading.textContent);
      if (!destination) continue;
      let node = heading.nextSibling;
      while (node && !(node.nodeType === 1 && /^H[1-6]$/.test(node.tagName))) {
        const next = node.nextSibling;
        content[destination].append(node);
        node = next;
      }
      heading.remove();
    }
    for (const paragraph of [...description.querySelectorAll('p')]) {
      if (classify(paragraph.textContent) === 'numbers') content.numbers.append(paragraph);
    }
    if (content.fitment.textContent.trim()) fallback.remove();
    else content.fitment.append(...fallback.childNodes);
    fallback.remove();
    if (!content.fitment.textContent.trim()) content.fitment.textContent = 'Check the description for sizing or compatibility information. Contact us if you need help choosing.';
    if (!content.numbers.textContent.trim()) content.numbers.innerHTML = '<p>Part numbers are shown with the product options above where available.</p>';
    const supplierRows = [];
    for (const row of [...content.numbers.querySelectorAll('tr')]) {
      const cells = [...row.children];
      const label = cells[0]?.textContent.trim().toLowerCase();
      const supplier = /^(parts europe|pe) sku$/.test(label || '') ? 'Parts Europe' : /^(mcs sku|supplier sku)$/.test(label || '') ? 'MCS' : null;
      if (supplier && cells.length === 2 && cells[1].tagName === 'TD') {
        cells[0].textContent = 'Product code';
        cells[0].setAttribute('scope', 'row');
        supplierRows.push(row);
      } else if (cells.length > 2) {
        for (const cell of cells) {
          if (cell.tagName === 'TH' && /^supplier sku$/i.test(cell.textContent.trim())) cell.textContent = 'Product code';
          if (cell.tagName === 'TH' && /^parts europe sku$/i.test(cell.textContent.trim())) cell.textContent = 'Product code';
        }
      }
    }
    if (supplierRows.length) {
      const heading = document.createElement('h3');
      heading.textContent = 'Product codes';
      const table = document.createElement('table');
      const body = document.createElement('tbody');
      body.append(...supplierRows);
      table.append(body);
      for (const existing of [...content.numbers.querySelectorAll('table')]) {
        if (!existing.querySelector('td')) existing.remove();
      }
      content.numbers.prepend(heading, table);
    }
    // Keep compatibility visible without opening a tab or disclosure.
    for (const details of content.fitment.querySelectorAll('details')) details.open = true;
    const fitmentPanel = content.fitment.closest('[data-panel]');
    const fitmentButton = this.querySelector('[data-tab="fitment"]');
    if (fitmentPanel && fitmentButton) {
      fitmentButton.remove();
      fitmentPanel.removeAttribute('role');
      fitmentPanel.removeAttribute('aria-labelledby');
      fitmentPanel.removeAttribute('tabindex');
      fitmentPanel.style.cssText = 'margin-top:24px;padding:24px;border:1px solid #c7c7c1;background:#f5f5f2;max-height:520px;overflow:auto';
      this.after(fitmentPanel);
    }
    const buttons = [...this.querySelectorAll('[data-tab]')];
    const panels = [...this.querySelectorAll('[data-panel]')];
    const select = index => {
      buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault(); select(next); buttons[next].focus();
      });
    });
    this.classList.add('is-ready');
    this.querySelector('[role="tablist"]').hidden = false;
    select(0);
  }
}
if (!customElements.get('deathproof-product-details')) customElements.define('deathproof-product-details', DeathproofProductDetails);